var e="data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4' fill='none'%3e %3ccircle cx='2' cy='2' r='2' fill='%237E7E7E'/%3e%3c/svg%3e";export{e as default};
//# sourceMappingURL=dot.svg.js.map
